import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=0416fde6&scoped=true&"
import script from "./Share.vue?vue&type=script&lang=js&"
export * from "./Share.vue?vue&type=script&lang=js&"
import style0 from "./Share.vue?vue&type=style&index=0&id=0416fde6&scoped=true&lang=css&"
import style1 from "./Share.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416fde6",
  null
  
)

export default component.exports